export default __webpack_public_path__ + "static/media/roadmap.9d042d32.png";